import { render, staticRenderFns } from "./Gameboard.vue?vue&type=template&id=387ccff1&scoped=true&"
import script from "./Gameboard.vue?vue&type=script&lang=js&"
export * from "./Gameboard.vue?vue&type=script&lang=js&"
import style0 from "./Gameboard.vue?vue&type=style&index=0&id=387ccff1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ccff1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
